<template>  <q-page class="CouponLa-style-page">
    <!-- Main content with pull-to-refresh -->
    <q-pull-to-refresh @refresh="onRefresh" class="main-content q-pt-md">
      <!-- Primary Hero Banner using BannersMobile component -->
      <div class="q-mb-sm">
        <BannersMobile
          :banners="mobileBanners"
          :loading="loading.banners"
          :error="errors.banners"
          @banner-click="handleBannerClick"
          @img-error="onImgError"
        />
      </div>
      
      <!-- Category Pills Scrollable Row -->
      <div class="category-pills q-px-md q-mb-md">
        <q-scroll-area horizontal style="height: 50px" class="full-width no-scrollbar">
          <div class="row no-wrap q-gutter-sm q-py-sm">
            <q-btn
              rounded
              :color="activeTab === 'all' ? 'primary' : 'grey-7'"
              :text-color="activeTab === 'all' ? 'white' : 'grey-7'"
              label="All"
              no-caps
              :flat="activeTab !== 'all'"
              :unelevated="activeTab === 'all'"
              class="category-pill"
              @click="activeTab = 'all'; filterByCategory('all')"
            />
            <q-btn
              v-for="category in topCategories"
              :key="category.id"
              rounded
              :color="activeTab === category.url_slug ? 'primary' : 'grey-7'"
              :text-color="activeTab === category.url_slug ? 'white' : 'grey-7'"
              :label="category.name"
              no-caps
              :flat="activeTab !== category.url_slug"
              :unelevated="activeTab === category.url_slug"
              class="category-pill"
              @click="activeTab = category.url_slug; filterByCategory(category.url_slug)"
            />
          </div>
        </q-scroll-area>
      </div>
        <!-- Today's Top Offers Section -->
      <section class="todays-offers-section q-mb-md">
        <div class="section-header q-px-md q-py-sm">
          <div class="row items-center justify-between">
            <div class="section-title">
              <div class="section-icon-container" style="background-color: #ff9800;">
                <q-icon name="whatshot" color="white" size="md" />
              </div>
              <span class="text-weight-medium">Today's Top Offers</span>
            </div>
            <q-btn flat dense color="primary" to="/featured" class="view-all">
              View all
              <q-icon name="chevron_right" size="sm" />
            </q-btn>
          </div>
        </div>
        
        <div v-if="!loading.featuredDeals && filteredDeals.length > 0" class="offers-grid q-px-md">
          <div class="row q-col-gutter-sm">
            <div v-for="deal in filteredDeals.slice(0, 6)" :key="deal.id" class="col-6 q-mb-sm">
              <div class="offer-card q-pa-xs" @click="goToCoupon(deal)" v-ripple>
                <div class="row no-wrap q-col-gutter-xs">
                  <div class="col-auto">
                    <q-avatar size="40px" class="q-ml-xs" square>
                      <q-img 
                        :src="deal.store && deal.store.logo_url ? deal.store.logo_url : '/images/offline-image-placeholder.png'" 
                        @error="onImgError"
                        transition="fade"
                      />
                    </q-avatar>
                  </div>
                  <div class="col">
                    <div class="offer-title q-mb-xs">{{ deal.title || 'Featured deal' }}</div>
                    <div v-if="deal.discount_value" class="discount-badge q-mb-xs">
                      {{ formatDiscount(deal) }}
                    </div>
                    <q-btn 
                      unelevated 
                      color="primary" 
                      :label="deal.code ? 'GET CODE' : 'VIEW DEAL'" 
                      @click.stop="trackCoupon(deal)" 
                      no-caps 
                      size="sm"
                      class="offer-btn"
                      :loading="loadingCoupon === deal.id"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-else-if="loading.featuredDeals" class="q-px-md">
          <div class="row q-col-gutter-sm">
            <div class="col-6" v-for="i in 4" :key="i">
              <q-skeleton type="rect" height="100px" class="q-mb-sm" animation="wave" />
            </div>
          </div>
        </div>
        
        <div v-else class="empty-state q-pa-md q-mx-md">
          <q-icon name="sentiment_dissatisfied" size="36px" color="grey-6" class="q-mb-sm" />
          <div class="text-subtitle2 text-grey-7 q-mb-sm">No offers available today</div>
          <q-btn flat color="primary" icon="refresh" label="Refresh" @click="refreshData" size="sm" />
        </div>
      </section>      <!-- Popular Stores Section -->
      <section class="popular-stores-section q-mb-lg">
        <div class="section-header q-px-md q-py-sm">
          <div class="row items-center justify-between">
            <div class="section-title">
              <div class="section-icon-container primary">
                <q-icon name="storefront" color="white" size="md" />
              </div>
              <span class="text-weight-medium">Popular Stores</span>
            </div>
            <q-btn flat dense color="primary" to="/stores" class="view-all">
              View all
              <q-icon name="chevron_right" size="sm" />
            </q-btn>
          </div>
        </div>
        
        <div v-if="!loading.stores && popularStores.length > 0" class="q-px-md">
          <div class="row q-col-gutter-md">
            <div 
              v-for="store in popularStores.slice(0, 8)" 
              :key="store.id" 
              class="col-3 q-mb-md"
            >              <div class="store-card" @click="goToStore(store)" v-ripple>                <div class="store-avatar">                  <q-img 
                    :src="store.logo_url || '/images/offline-image-placeholder.png'" 
                    width="60px" 
                    height="60px" 
                    class="store-logo" 
                    @error="onImgError"
                    contain
                    transition="fade"
                    fit="contain"
                    no-spinner
                    no-native-menu
                  />
                </div>
                <div class="store-name">{{ store.name }}</div>
              </div>
            </div>
          </div>
        </div>
            <div v-else-if="loading.stores" class="q-px-md q-py-sm">
          <div class="row q-col-gutter-md">
            <div class="col-3" v-for="i in 8" :key="i">
              <q-skeleton class="store-skeleton" height="90px" animation="wave" />
            </div>
          </div>
        </div>
        
        <div v-else class="empty-state q-pa-md q-mx-md">
          <q-icon name="info" size="36px" color="grey-7" class="q-mb-sm" />
          <div class="text-subtitle2 text-grey-7">No stores available</div>
        </div>
      </section>      <!-- Best Coupons Today Section -->
      <section class="best-coupons-section q-mb-lg">
        <div class="section-header q-px-md q-py-sm">
          <div class="row items-center justify-between">
            <div class="section-title">
              <div class="section-icon-container secondary">
                <q-icon name="local_offer" color="white" size="md" />
              </div>
              <span class="text-weight-medium">Best Coupons Today</span>
            </div>
            <q-btn flat dense color="primary" to="/coupons" class="view-all">
              View all
              <q-icon name="chevron_right" size="sm" />
            </q-btn>
          </div>
        </div>
          <div v-if="!loading.latestCoupons && filteredCoupons.length > 0" class="q-px-md">
          <div class="row q-col-gutter-md">            <div v-for="coupon in filteredCoupons.slice(0, 6)" :key="coupon.id" class="col-6 q-mb-md">
              <div class="coupon-card" @click="goToCoupon(coupon)" v-ripple>
                <div class="coupon-inner">
                  <div class="store-logo-container">
                    <q-img 
                      :src="coupon.store && coupon.store.logo_url ? coupon.store.logo_url : '/images/offline-image-placeholder.png'" 
                      class="coupon-logo"
                      @error="onImgError"
                      fit="contain"
                      no-spinner
                    />
                  </div>
                  
                  <div class="coupon-content q-pa-sm">
                    <div class="row justify-between items-center q-mb-xs">
                      <div class="text-caption text-weight-medium text-primary">{{ coupon.store ? coupon.store.name : 'Shop now' }}</div>
                      <q-chip v-if="coupon.is_exclusive" size="xs" color="red-8" text-color="white" dense>
                        Exclusive
                      </q-chip>
                    </div>
                    
                    <div class="coupon-title q-mb-sm">{{ coupon.title }}</div>
                    
                    <div v-if="coupon.success_rate" class="coupon-success-rate text-caption text-green-7 q-mb-xs">
                      <q-icon name="thumb_up" size="xs" class="q-mr-xs" />
                      {{ coupon.success_rate }}% Success
                    </div>
                    
                    <div class="row justify-end q-mt-sm">
                      <span v-if="coupon.code" class="coupon-code" @click.stop="copyCouponCode(coupon.code)">
                        {{ coupon.code }}
                        <q-icon name="content_copy" size="xs" class="q-ml-xs" />
                      </span>
                      <q-btn 
                        v-else 
                        class="get-deal-btn" 
                        color="primary" 
                        size="sm"
                        label="Get Deal" 
                        @click.stop="trackCoupon(coupon)"
                        no-caps
                        :loading="loadingCoupon === coupon.id"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-else-if="loading.latestCoupons" class="q-px-md">
          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6" v-for="i in 4" :key="i">
              <q-skeleton type="rect" class="q-mb-md" height="120px" animation="wave" />
            </div>
          </div>
        </div>
        
        <div v-else class="empty-state q-pa-md q-mx-md">
          <q-icon name="info" size="36px" color="grey-7" class="q-mb-sm" />
          <div class="text-subtitle2 text-grey-7">No coupons available</div>
        </div>
      </section>      <!-- Categories Section -->
      <section class="categories-section q-mb-lg">
        <div class="section-header q-px-md q-py-sm">
          <div class="row items-center justify-between">
            <div class="section-title">
              <div class="section-icon-container accent">
                <q-icon name="category" color="white" size="md" />
              </div>
              <span class="text-weight-medium">Shop by Category</span>
            </div>
            <q-btn flat dense color="primary" to="/categories" class="view-all">
              View all
              <q-icon name="chevron_right" size="sm" />
            </q-btn>
          </div>
        </div>          <div v-if="!loading.categories && categories.length > 0" class="category-grid q-px-md">
          <div class="row q-col-gutter-sm">
            <div 
              v-for="category in categories.slice(0, 9)" 
              :key="category.id" 
              class="col-4 col-sm-3 q-mb-xs"
            >
              <div 
                class="category-card" 
                @click="goToCategory(category)" 
                v-ripple
              >
                <div class="category-card-inner" :style="{ background: getCategoryBgColor(category) }">
                  <div class="category-icon-container">
                    <q-icon :name="category.icon || 'category'" color="white" size="20px" />
                  </div>
                  <div class="category-content">
                    <div class="category-name">{{ category.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>        <div v-else-if="loading.categories" class="q-px-md q-py-sm">
          <div class="row q-col-gutter-sm">
            <div class="col-4 col-sm-3" v-for="i in 9" :key="i">
              <q-skeleton type="rect" class="category-skeleton" height="70px" animation="wave" />
            </div>
          </div>
        </div>
        
        <div v-else class="empty-state q-pa-md q-mx-md">
          <q-icon name="info" size="36px" color="grey-7" class="q-mb-sm" />
          <div class="text-subtitle2 text-grey-7">No categories available</div>
        </div>
      </section>

      <!-- Newsletter Section -->
      <section class="newsletter-section q-mb-lg q-px-md">
        <div class="newsletter-card q-pa-md">
          <div class="row items-center">
            <div class="col-12">
              <div class="text-h6 q-mb-sm">Stay Updated</div>
              <p class="text-caption q-mb-md">Subscribe to our newsletter for exclusive deals and offers.</p>
              
              <q-form @submit="handleNewsletterSignup" class="row q-col-gutter-sm">
                <div class="col-12 col-sm-8">
                  <q-input 
                    v-model="newsletterEmail" 
                    type="email" 
                    placeholder="Your email address" 
                    outlined 
                    dense
                    :rules="[val => emailPattern.test(val) || 'Please enter a valid email']"
                  />
                </div>
                <div class="col-12 col-sm-4">
                  <q-btn 
                    type="submit" 
                    color="primary" 
                    label="Subscribe" 
                    class="full-width" 
                    :loading="loading.newsletter"
                    no-caps
                  />
                </div>
              </q-form>
            </div>
          </div>
        </div>
      </section>
      
      <!-- App Banner Removed -->
    </q-pull-to-refresh>
    
    <!-- Coupon Detail Dialog -->
    <CouponDetailDialog
      v-if="selectedCoupon"
      v-model="showCouponDialog"
      :coupon="selectedCoupon"
    />
  </q-page>
</template>

<script>
import { defineComponent, ref, computed, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useQuasar, copyToClipboard } from 'quasar';
import { couponsService, storesService, categoriesService } from '../../services/supabase';
import { supabase } from '../../services/supabase';
import { formatDate } from '@/utils/dateUtils';
import CouponDetailDialog from '@/components/coupon/CouponDetailDialog.vue';
import BannersMobile from '@/components/public/BannersMobile.vue';

export default defineComponent({
  name: 'HomeMobile',
  components: {
    CouponDetailDialog,
    BannersMobile
  },
  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },
  
  emits: ['update:searchQuery'],
  
  setup(props, { emit }) {
    const $q = useQuasar();
    const router = useRouter();
      // Dialog and coupon state
    const showCouponDialog = ref(false);
    const selectedCoupon = ref(null);
    
    // Core state
    const storeTab = ref(0);
    const categoryTab = ref(0);
    const activeTab = ref('all');
    const newsletterEmail = ref('');
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const loadingCoupon = ref(null);
    const drawer = ref(false);
    const slide = ref(0);

    // Data stores
    const featuredDeals = ref([]);
    const filteredDeals = ref([]);
    const popularStores = ref([]);
    const latestCoupons = ref([]);
    const filteredCoupons = ref([]);
    const categories = ref([]);
    const mobileBanners = ref([]);
    // Computed: Only unique store deals for hero banners
    const uniqueStoreDeals = computed(() => {
      const seen = new Set();
      return filteredDeals.value.filter(deal => {
        const storeId = deal.store?.id || deal.store_id || deal.id; // fallback to deal id if no store
        if (!storeId || seen.has(storeId)) return false;
        seen.add(storeId);
        return true;
      });
    });
    const topCategories = computed(() => {
      // Sort categories by name for now, but you could use popularity in future
      if (!categories.value || categories.value.length === 0) return [];
      // Return top 8 categories at most
      return categories.value.slice(0, 8);
    });    // Loading states
    const loading = reactive({
      featuredDeals: true,
      stores: true,
      latestCoupons: true,
      categories: true,
      newsletter: false,
      banners: true
    });

    // Error states
    const errors = reactive({
      featuredDeals: null,
      stores: null,
      latestCoupons: null,
      categories: null,
      newsletter: null,
      banners: null
    });

    // Computed properties for chunked lists
    const itemsPerPage = 6;
    
    const chunkedStores = computed(() => {
      return chunkArray(popularStores.value, itemsPerPage);
    });
    
    const chunkedCategories = computed(() => {
      return chunkArray(categories.value, itemsPerPage);
    });    // Initialize data
    onMounted(() => {
      fetchFeaturedDeals();
      fetchPopularStores();
      fetchLatestCoupons();
      fetchCategories();
      fetchBannerAds();
      // Set default active tab
      activeTab.value = 'all';
    });
    
    // Helper for chunking arrays for pagination
    function chunkArray(array, size) {
      if (!array.length) return [];
      
      const chunkedArr = [];
      let index = 0;
      
      while (index < array.length) {
        chunkedArr.push(array.slice(index, size + index));
        index += size;
      }
      
      return chunkedArr;
    }

    // API data fetching methods
    async function fetchFeaturedDeals() {
      loading.featuredDeals = true;
      errors.featuredDeals = null;
      
      try {
        const { data, error } = await couponsService.getAll({ isFeatured: true });
        
        if (error) throw error;
        
        featuredDeals.value = data || [];
        // Initialize filtered deals with all deals
        filteredDeals.value = [...featuredDeals.value];
      } catch (err) {
        console.error('Error fetching featured deals:', err);
        errors.featuredDeals = err.message;
      } finally {
        loading.featuredDeals = false;
      }
    }
    
    async function fetchPopularStores() {
      loading.stores = true;
      errors.stores = null;
      
      try {
        const { data, error } = await storesService.getFeatured();
        
        if (error) throw error;
        
        popularStores.value = data || [];
      } catch (err) {
        console.error('Error fetching popular stores:', err);
        errors.stores = err.message;
      } finally {
        loading.stores = false;
      }
    }
    
    async function fetchLatestCoupons() {
      loading.latestCoupons = true;
      errors.latestCoupons = null;
      
      try {
        const { data, error } = await couponsService.getAll({ active: true }, 1, 8);
        
        if (error) throw error;
        
        latestCoupons.value = data || [];
        // Initialize filtered coupons with all coupons
        filteredCoupons.value = [...latestCoupons.value];
      } catch (err) {
        console.error('Error fetching latest coupons:', err);
        errors.latestCoupons = err.message;
      } finally {
        loading.latestCoupons = false;
      }
    }
    
    async function fetchCategories() {
      loading.categories = true;
      errors.categories = null;
      
      try {
        const { data, error } = await categoriesService.getAll();
        
        if (error) throw error;
        
        categories.value = data || [];
      } catch (err) {
        console.error('Error fetching categories:', err);
        errors.categories = err.message;
      } finally {
        loading.categories = false;
      }
    }    // New method to fetch banner ads
    async function fetchBannerAds() {
      loading.banners = true;
      errors.banners = null;
      
      try {
        // Direct Supabase query since we don't have a dedicated service for banners yet
        const { data, error } = await supabase
          .from('banner_ads')
          .select('*')
          .eq('is_active', true)
          .eq('is_mobilebanner', true)
          .order('display_order', { ascending: true });
        
        if (error) throw error;
        
        mobileBanners.value = data || [];
      } catch (err) {
        console.error('Error fetching banner ads:', err);
        errors.banners = err.message;
      } finally {
        loading.banners = false;
      }
    }
    
    // UI interaction methods
    function onRefresh(done) {
      Promise.all([
        fetchFeaturedDeals(),
        fetchPopularStores(),
        fetchLatestCoupons(),
        fetchCategories(),
        fetchBannerAds()
      ]).finally(() => {
        done();
        $q.notify({
          message: 'Content refreshed',
          color: 'positive',
          position: 'top',
          timeout: 1000
        });
      });
    }
    
    function refreshData() {
      Promise.all([
        fetchFeaturedDeals(),
        fetchPopularStores(),
        fetchLatestCoupons(),
        fetchCategories(),
        fetchBannerAds()
      ]);
    }

    function filterByCategory(categorySlug) {
      console.log(`Filtering by category: ${categorySlug}`);
      
      // Reset to original data if "all" is selected
      if (categorySlug === 'all') {
        filteredDeals.value = [...featuredDeals.value];
        filteredCoupons.value = [...latestCoupons.value];
        return;
      }
      
      // Find the selected category
      const selectedCategory = categories.value.find(cat => cat.url_slug === categorySlug);
      if (!selectedCategory) {
        console.error(`Category not found: ${categorySlug}`);
        return;
      }
      
      // Filter deals by category
      filteredDeals.value = featuredDeals.value.filter(deal => {
        // Check if the store is in the selected category
        if (deal.store && deal.store.categories) {
          return deal.store.categories.some(cat => cat.id === selectedCategory.id);
        }
        // If deal has direct category association
        if (deal.category_id) {
          return deal.category_id === selectedCategory.id;
        }
        return false;
      });
      
      // Filter coupons by category
      filteredCoupons.value = latestCoupons.value.filter(coupon => {
        // Check if the store is in the selected category
        if (coupon.store && coupon.store.categories) {
          return coupon.store.categories.some(cat => cat.id === selectedCategory.id);
        }
        // If coupon has direct category association
        if (coupon.category_id) {
          return coupon.category_id === selectedCategory.id;
        }
        return false;
      });
      
      // Show notification if no results found
      if (filteredDeals.value.length === 0 && filteredCoupons.value.length === 0) {
        $q.notify({
          message: `No offers found in ${selectedCategory.name}`,
          color: 'info',
          position: 'top',
          timeout: 2000
        });
      }
    }
    
    async function handleNewsletterSignup() {
      if (!emailPattern.test(newsletterEmail.value)) return;
      
      loading.newsletter = true;
      
      try {
        // You would need to implement this in a backend service
        // For now, we'll just show a success notification
        setTimeout(() => {
          $q.notify({
            message: 'Thank you for subscribing!',
            color: 'positive',
            position: 'top',
            timeout: 2000
          });
          newsletterEmail.value = '';
          loading.newsletter = false;
        }, 1000);
      } catch (err) {
        $q.notify({
          message: 'Failed to subscribe. Please try again.',
          color: 'negative',
          position: 'top',
          timeout: 2000
        });
        loading.newsletter = false;
      }
    }
    
    // Format discount value based on type
    function formatDiscount(coupon) {
      if (!coupon.discount_value) return '';
      
      if (coupon.discount_type === 'percentage') {
        return `${coupon.discount_value}% OFF`;
      } else if (coupon.discount_type === 'fixed') {
        return `Γé╣${coupon.discount_value} OFF`;
      }
      
      return coupon.discount_value;
    }
    
    // Format expiry date
    function formatExpiryDate(expiryDate) {
      if (!expiryDate) return 'No expiry';
      
      const expiry = new Date(expiryDate);
      const today = new Date();
      const diffDays = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
      
      if (diffDays < 0) return 'Expired';
      if (diffDays === 0) return 'Expires today';
      if (diffDays === 1) return 'Expires tomorrow';
      if (diffDays < 30) return `Expires in ${diffDays} days`;
      
      return formatDate(expiryDate, 'MMM D, YYYY');
    }
    
    // Copy coupon code to clipboard
    function copyCouponCode(code) {
      copyToClipboard(code)
        .then(() => {
          $q.notify({
            message: 'Code copied to clipboard!',
            color: 'positive',
            position: 'top',
            timeout: 2000
          });
        })
        .catch(() => {
          $q.notify({
            message: 'Failed to copy code',
            color: 'negative',
            position: 'top',
            timeout: 2000
          });
        });
    }
    
    // Toggle drawer menu
    function toggleDrawer() {
      drawer.value = !drawer.value;
    }
        // Track coupon click and redirect
    async function trackCoupon(coupon) {
      loadingCoupon.value = coupon.id;
      try {
        // Track the click (optional, can keep for analytics)
        await couponsService.trackClick(coupon.id);
        
        // Set the selected coupon and show the dialog first
        selectedCoupon.value = coupon;
        showCouponDialog.value = true;
        
        // If it has a code, copy it to clipboard
        if (coupon.code) {
          await copyToClipboard(coupon.code);
          $q.notify({
            message: 'Code copied to clipboard!',
            color: 'positive',
            position: 'top',
            timeout: 2000,
            icon: 'content_copy'
          });
        }
        
        // Small delay for better UX
        setTimeout(() => {
          // Open the affiliate redirect in a new tab
          window.open(`https://autoredirect.CouponLa-india.workers.dev/${coupon.id}`, '_blank');
          loadingCoupon.value = null;
        }, 300);
      } catch (err) {
        console.error('Error tracking coupon click:', err);
        // Redirect anyway in case of error
        window.open(`https://autoredirect.CouponLa-india.workers.dev/${coupon.id}`, '_blank');
        loadingCoupon.value = null;
      }
    }
      // Navigation helpers
    function goToCoupon(coupon) {
      // Set the selected coupon and show the dialog
      selectedCoupon.value = coupon;
      showCouponDialog.value = true;
      
      // Delay opening the URL slightly to ensure dialog appears first
      setTimeout(() => {
        window.open(`https://autoredirect.CouponLa-india.workers.dev/${coupon.id}`, '_blank');
      }, 100);
    }
    
    function goToStore(store) {
      router.push(`/store/${store.url_slug || store.id}`);
    }
      function goToCategory(category) {
      router.push(`/category/${category.url_slug || category.id}`);
    }
    
    // Banner click handler
    function handleBannerClick(banner) {
      console.log('Banner clicked:', banner);
      
      // Open the banner URL in a new tab
      if (banner && banner.link_url) {
        window.open(banner.link_url, '_blank');
      }
    }
      // Generate background colors for categories
    function getCategoryBgColor(category) {
      // Modern gradient combinations
      const colors = [
        'linear-gradient(135deg, #4776E6, #8E54E9)',
        'linear-gradient(135deg, #00c6fb, #005bea)',
        'linear-gradient(135deg, #FF3E9D, #0E1F40)',
        'linear-gradient(135deg, #ff9966, #ff5e62)',
        'linear-gradient(135deg, #184e68, #57ca85)',
        'linear-gradient(135deg, #5614B0, #DBD65C)',
        'linear-gradient(135deg, #2b5876, #4e4376)',
        'linear-gradient(135deg, #f953c6, #b91d73)'
      ];
      
      // Backup branded colors
      const backupColors = [
        '#4CAF50', // Green
        '#2196F3', // Blue
        '#FF5722', // Deep Orange
        '#9C27B0', // Purple
        '#3F51B5', // Indigo
        '#00BCD4', // Cyan
        '#FFC107', // Amber
        '#795548'  // Brown
      ];
      
      // Simple hash function to generate color based on category name
      const hash = category.name.split('').reduce(
        (hash, char) => char.charCodeAt(0) + ((hash << 5) - hash), 0
      );
      
      // Try to use predefined color or icon-specific color if available
      if (category.color) {
        return category.color;
      }
      
      // Associate specific colors with common category icons
      const iconColorMap = {
        'local_mall': colors[0],
        'shopping_cart': colors[1],
        'card_giftcard': colors[2],
        'restaurant': colors[3],
        'flight': colors[4],
        'hotel': colors[5],
        'devices': colors[6],
        'directions_car': colors[7]
      };
      
      if (category.icon && iconColorMap[category.icon]) {
        return iconColorMap[category.icon];
      }
      
      // Fallback to a hashed color from our array
      return colors[Math.abs(hash) % colors.length];
    }
    
    // Handle image load errors
    function onImgError(err) {
      // Set default placeholder image
      err.target.src = '/images/offline-image-placeholder.png';
    }    return {
      // Reactive state
      storeTab,
      categoryTab,
      activeTab,
      newsletterEmail,
      emailPattern,
      featuredDeals,
      filteredDeals,
      popularStores,
      latestCoupons,
      filteredCoupons,
      categories,
      topCategories,
      loading,
      errors,
      chunkedStores,
      chunkedCategories,
      drawer,
      slide,
      showCouponDialog,
      selectedCoupon,
      mobileBanners,
      // Methods
      onRefresh,
      refreshData,
      filterByCategory,
      handleNewsletterSignup,
      formatDiscount,
      formatExpiryDate,
      copyCouponCode,
      trackCoupon,      goToCoupon,
      goToStore,
      goToCategory,
      getCategoryBgColor,
      onImgError,
      loadingCoupon,
      toggleDrawer,
      uniqueStoreDeals,
      handleBannerClick
    };
  }
});
</script>

<style lang="scss">
/* Import the styles */
@import './HomeMobile.scss';

/* Additional custom styles specific to this component */
.min-w-200 {
  min-width: 200px;
}

/* Fix for Safari image rendering */
.q-img__image {
  object-fit: cover;
}

/* Fix for store logos - optimized for SVG images */
.store-logo {
  .q-img__image {
    object-fit: contain !important;
    max-width: 100%;
    max-height: 100%;
    filter: none;
    background-blend-mode: normal;
    background-color: transparent;
  }
}

/* Added style for store avatar to eliminate white borders */
.store-avatar {
  background-color: #f8f9fa !important;
  border-radius: 12px !important;
}

/* Smooth animations */
.q-tab-panels--animated .q-tab-panel {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Pull to refresh color */
.q-pull-to-refresh__content {
  background-color: #f5f7fa;
}

/* Enhanced deal image styles */
.deal-img {
  transition: transform 0.3s ease;
}

.modern-deal-card:hover .deal-img {
  transform: scale(1.03);
}

/* Improved transitions */
.q-img.q-img--fade .q-img__image {
  transition: opacity 0.5s;
}

/* Accessibility enhancements */
.modern-code-chip:focus {
  outline: 2px solid var(--q-primary);
  outline-offset: 2px;
}

/* Category pills scroll area fixes */
.no-scrollbar ::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* Carousel slide image fit */
.q-carousel-slide .q-img__image, .q-carousel-slide img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.carousel-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  /* Specific handling for SVG images */
  :deep(.q-img__content) {
    background-color: white;
  }
  
  :deep(.q-img__image) {
    object-fit: contain;
    max-width: 90%;
    max-height: 90%;
    margin: auto;
  }
}

.q-carousel {
  background-color: #f5f7fa;
}
</style>
